<template>

</template>

<script>
    import {onMounted} from 'vue';
    import { useRouter } from "vue-router";
    import basicApi from '../public/http/index';

    export default {
        setup(){
            onMounted(() => {
                useRouter().push('/home/homepage')

                let collogeId = localStorage.getItem('collogeId')






            })
        }
    }
</script>

<style scoped>

</style>
